import React from 'react'
import './Accessibilty.css'

const AccessibilityHe = () => {
  return (
   
    <>
        <div className='accessibilty-container'>
           <h1>הצהרת נגישות אתר OPEN DATA עיריית תל אביב</h1>
           <p>עיריית תל-אביב-יפו רואה חשיבות עליונה בהנגשת שירותיה לאנשים עם מוגבלות.<br /></p>
           <p>באתר OPEN DATA בוצעו התאמות נגישות כנדרש, עפ&quot;י תקנות שוויון זכויות לאנשים עם מוגבלות (התאמות נגישות לשירות) תשע&quot;ג-2013, ת&quot;י 5568 - תקן להנגשת אתרי אינטרנט לבעלי מוגבלויות ולתקןW3C&#39;s Web Content Accessibility Guidelines 2.0, level AA.</p>
           <h2>להלן פרוט הסדרי הנגישות באתר<br /></h2>
           <p>לכל מאגר יש מספר תצוגות:</p>
           <ol>
              <li>מידע – מידע טקסטואלי על המאגר</li>
              <li>טבלה – לקבלת הנתונים באופן נגיש לקוראי מסך ולמשתמשי מקלדת מומלץ להוריד את קובץ האקסל למחשב באמצעות לחיצה על הקישור &quot;פתיחת הטבלה בקובץ אקסל&quot;</li>
              <li>תרשימים – התרשימים מוצגים באמצעות מערכת במערכת PowerBI של חברת Microsoft.
                 <ul>
                    <li>כדי להגיע עם המקלדת לאזור התרשימים יש ללחוץ על TAB עד שאזור התרשים מסומן במסגרת שחורה, לחצו על CRTL+ENTER , משם ניתן לעבור על כל החלקים באמצעות מקש tab – כניסה לתוך אזור מקש &#160;Enter ויציאה מאזור מקש ESC.</li>
                    <li>למשתמשי קורא – בהגעה לתרשים לחצו על CTRL ALT F11 כדי לקבל טבלה נגישה של הנתונים.</li>
                    <li>
                       <a href="https://docs.microsoft.com/he-il/power-bi/desktop-accessibility-keyboard-shortcuts"  >למידע נוסף על ניווט במערכת באמצעות מקלדת</a>
                     </li>
                     <li>ראו 
                        <a href="https://youtu.be/l2gu6vRtT-s" >סרטון הדגמה לגלישה בתרשימים באמצעות מקלדת</a>
                        <span lang="HE" >.</span>
                     </li>
                  </ul></li>
     <li>API – קישור לקוד API להתממשקות למאגר</li>
     <li>מפה – לקבלת המפה באופן נגיש לקוראי מסך ולמשתמשי מקלדת מומלץ לפתוח את המפה בחלון חדש במערכת ה GIS העירונית באמצעות לחיצה על הקישור &quot;פתח מפה בחלון חדש&quot;&#160;<br /></li>
    </ol>
    <><p>
       </p><h2>סייגים לנגישות: </h2><p>
          </p><p>האתר עושה שימוש במערכת PowerBI של חברת Microsoft לצורך הצגת תרשימים. דפדפנים נתמכים על ידי PowerBI הם Chrome או Edge. נגישות אינה נתמכת בתצוגת מובייל.</p><p>יש לציין שקורא מסך עובד היטב עם המערכת אולם הוא מגיב לאט מומלץ להמתין בסבלנות להקראה לאחר כל פעולת ניווט עם המקלדת.<br /></p><h2>פניות ומידע על הצהרת הנגישות</h2><p>
             <a href="https://www.tel-aviv.gov.il/Transparency/Pages/AccessibilityStatement.aspx"><span lang="HE" dir="rtl" >לפניות בנושה נגישות ולפרטי רכז הנגישות של העירייה ופניות בנושא נגישות</span></a></p><p>האתר נבדק עם בדפדפן כרום ועם קורא מסך JAWS, אזור התרשימים באתר נבדק
             <a href="https://docs.microsoft.com/he-il/power-bi/desktop-accessibility-keyboard-shortcuts">
                <span lang="HE" dir="rtl" >בהתאם להנחיות לשימוש במקלדת של מיקרוסופט</span></a></p><p>תאריך עדכון הצהרת נגישות: 15.12.2021</p></>
                </div>
    </>
  )
}

export default AccessibilityHe